import { useGame } from '../context/GameContext';

export const usePortfolioStats = () => {
  const { gameState, calculateNetWorth } = useGame();

  // Format stats for header display
  const getHeaderStats = () => {
    const formatCurrency = (value) => {
      if (value >= 1000000) {
        return `$${(value / 1000000).toFixed(1)}M`;
      } else if (value >= 1000) {
        return `$${(value / 1000).toFixed(1)}K`;
      } else {
        return `$${Math.round(value)}`;
      }
    };

    const calculateUnrealizedPL = () => {
      if (!gameState.portfolio || gameState.portfolio.length === 0) {
        return 0;
      }
      
      return gameState.portfolio.reduce((total, position) => {
        const currentValue = position.quantity * (position.currentPrice || position.averagePrice || 0);
        const cost = position.quantity * (position.averagePrice || 0);
        return total + (currentValue - cost);
      }, 0);
    };

    const formatPLCurrency = (value) => {
      const formatted = formatCurrency(Math.abs(value));
      return value >= 0 ? `+${formatted}` : `-${formatted}`;
    };

    const statsResult = {
      cash: formatCurrency(gameState.cash || 0),
      'unrealized p&l': formatPLCurrency(calculateUnrealizedPL()),
      netWorth: Math.round(calculateNetWorth() || 0)
    };
    
    // Return placeholder if stats are empty
    if (gameState.cash === 0 && gameState.savingsBalance === 0 && gameState.totalInvested === 0) {
      return {
        cash: '---',
        'unrealized p&l': '---',
        netWorth: 0
      };
    }
    
    return statsResult;
  };

  return {
    gameState,
    calculateNetWorth,
    getHeaderStats
  };
};